import React, { useEffect, useState } from 'react';
import axios from "axios";
import base64 from "base-64"
import { useForm } from "react-hook-form";
import HomeIcon from '../assests/icons/home.svg';
import u from '../assests/icons/u.svg';
import ufilled from '../assests/icons/u(filled).svg'
import HomeIcon2 from '../assests/webicons/homefilled.svg';
import BriefCase from '../assests/webicons/briefcase.svg';
import BriefCase2 from '../assests/webicons/briefcase-filled.svg';

import dollar from '../assests/icons/dollar.svg';
import dollarfilled from '../assests/icons/dollar(filled).svg';
import '../assests/css/mapform.css'
//tool-tip
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ENV from '../env';
import moment from 'moment';
import summaryHomeApi from '../services/summaryHomeApi';


const { forwardRef, useRef, useImperativeHandle } = React;
const toastList = new Set();
const MAX_TOAST = 1;

const MapForm = forwardRef((props, ref) => {
    const history = useHistory();
    const [userData, setUserData] = useState({})
    const [nameError, setNameError] = useState(false)
    const [loading, setLoading] = useState(false)
    const [bill, setBill] = useState(true)
    const [originalName, setOriginalName] = useState("");
    const [submitData, setSubmitData] = useState({
        activities: [],
        name: "",
        notes: "",
        category: "",
        billable: ""
    })
    const [summaryData, setSummaryData] = useState(false)

    const { handleSubmit, formState: { errors } } = useForm();

    const toastId = React.useRef(null);

    const updateActivities = (payload) => {
        Promise.all([
            localStorage.getItem('userId'),
            localStorage.getItem('sToken')
        ]).then(async (res) => {
            let userId = JSON.parse(res[0]);
            let sToken = JSON.parse(res[1]);
            let header = base64.encode(`${userId}:${sToken}`);
            let security = `Basic ${header}`;
                 
            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Security': security,
                    'Content-Type': 'application/json',
                }
            };

            let updateUrl = `${ENV.LOCUSB_API}/UpdateActivities`
            axios.post(updateUrl, payload, options)
                .then(response => {
                    if (response.data.success === "true") {
                        props.updateState(props.cardIDs, props.sortBy)
                   
                    }
                    else {
                        if (response.data.errorMsg === "Invalid_SecureToken") {
                            toast.error("Session expired, Please login again")
                            history.push('/')
                        }
                        else {
                            // console.log("something went wrong in update activity API", response.data.errorMsg)
                            toast.error(response.data.errorMsg)
                        }
                    }
                }).catch(err => {
                    console.log("error from update activity api", err)
                })

        }).catch((err) => {
            console.log("api catch err", err)
        })
    }
     
    const onSubmit = data => {
        setSummaryData(!summaryData)
        setLoading(true)
        if(submitData.name.length === 0){
             return console.log("name felid is blank"),
                setLoading(false)        
        }
        if(userData.length === 0) {
            // return toast.warning("Please select the any activity")
            return console.log("Please select the any activity")
        }
        if (userData.length > 0 && submitData.name.length === 0) {
            return setNameError(true)
        }
        data.activities = userData?.map((el) => el.id);
        updateActivities({
            ...submitData,
            category: submitData.category.length === 0 ? "" : submitData.category.charAt(0)
        })
    
    }
    
    useEffect(() => {
         console.log("map form data=========", props)
        setUserData(props?.data)
        setFormData(props?.data) ;
        submitData.name.length > 0 && setNameError(false)
    }, [props.data]);

    const setFormData = (userData) => {
        submitData.activities = userData && Object.keys(userData).length === 0 || userData.length === 0 ? '' : userData.map((el) => el.id);

        if (userData !== undefined) {
            if (userData.length > 1) {
                setSubmitData({ ...submitData, activities: userData.map((el) => el.id) })
                if (userData.every(v => v.customerName === userData[0].customerName) && userData.every(v => v.classification.charAt(0) === userData[0].classification.charAt(0)) && userData[0].notes !== null && userData.every(v => v.notes === userData[0].notes)) {
                    console.log("All same", userData[0])
                    setOriginalName(userData[0].customerName);
                    setSubmitData({ ...submitData, name: userData[0].customerName, category: userData[0].classification.charAt(0), billable: userData[0].billable, notes: userData[0].notes })
                } else {
                    if (userData.every(v => v.customerName === userData[0].customerName && userData.every(v => v.classification.charAt(0) === userData[0].classification.charAt(0)))) {
                        console.log("customerName and classification same", userData[0].customerName, userData[0].classification);
                        setOriginalName(userData[0].customerName);
                        setSubmitData({ ...submitData, name: userData[0].customerName, category: userData[0].classification.charAt(0), notes: '', billable: userData[0].billable })
                    } else {
                        if (userData.every(v => v.customerName === userData[0].customerName && userData[0].notes !== null && userData.every(v => v.notes === userData[0].notes))) {
                            console.log("both customerName and notes", userData[0].customerName, userData[0].notes.length);
                            setOriginalName(userData[0].customerName);
                            setSubmitData({ ...submitData, name: userData[0].customerName, notes: userData[0].notes, category: '' })
                        } else {
                            if (userData.every(v => v.classification.charAt(0) === userData[0].classification.charAt(0) && userData[0].notes !== null && userData.every(v => v.notes === userData[0].notes))) {
                                console.log("both classification and notes", userData[0].classification, userData[0].notes);
                                setOriginalName('');
                                setSubmitData({ ...submitData, category: userData[0].classification.charAt(0), billable: userData[0].billable, notes: userData[0].notes, name: '' })
                            } else {
                                if (userData.every(v => v.customerName === userData[0].customerName)) {
                                    console.log("only same customerName", userData[0].customerName);
                                    setOriginalName(userData[0].customerName);
                                    setSubmitData({ ...submitData, name: userData[0].customerName, category: '', notes: '' })
                                } else {
                                    if (userData.every(v => v.classification.charAt(0) === userData[0].classification.charAt(0))) {
                                        setOriginalName('');
                                        console.log("only same classification", userData[0].classification)
                                        setSubmitData({ ...submitData, category: userData[0].classification, name: '', billable: userData[0].billable, notes: '' })
                                    } else {
                                        if (userData.every(v => v.notes === userData[0].notes) && userData[0].notes !== null) {
                                            setOriginalName('');
                                            console.log("only same notes", userData[0].notes)
                                            setSubmitData({ ...submitData, notes: userData[0].notes, category: '', name: '' })
                                        }
                                        else { setSubmitData({ ...submitData, category: '', name: '', notes: '' }) }
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                if (userData.length === 1) {
                    // console.log("userdata", userData[0])
                    setOriginalName(userData[0].customerName);
                    setSubmitData({ ...submitData, name: userData[0].customerName, notes: userData[0].notes, category: userData[0].classification.charAt(0), billable: userData[0].billable })
                } else {
                    setSubmitData({ ...submitData, name: '', notes: userData[0]?.notes, category: '' })
                }
            }
        }
        else {
            setSubmitData({ ...submitData, name: '', category: '', notes: '' })
        }
    }
console.log("bill",bill);
    useImperativeHandle(ref, () => ({
        getAlert() {
            // console.log("getAlert from Child");
            setLoading(false);
        }
    }));

    console.log("submit data1", submitData.name)
                                           
    return (
        <div style={{ fontFamily: "Poppins" }}>
            <div style={{ width: "100%" }}>
                <div style={{ paddingInline: "10rem" }}>
                </div>
                <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div style={{ textAlign: "center" }}>
                            {/* Customer name input field */}
                            <div className="form-group input-group" style={{ display: "grid" }}>
                                <span className='inputBoxStyle'>
                                    <input className="inputstyle form-control form-control-sm" disabled={submitData.activities.length === 0} placeholder="Activity Name" type="text" value={(submitData.activities.length === 1) ? submitData?.name: [submitData.activities.length > 1 ? submitData?.name: ""]}
 onChange={e => { setSubmitData({ ...submitData, name: e.target.value }) }}
 />
                                </span>
                            </div>
                            {/* Address input field */}
                            <div className="form-group input-group input-group-sm">
                                <span className='inputBoxStyle'>
                                    <textarea rows="2" style={{resize: "none"}} className="inputstyle border-none form-control form-control-sm" type="text" disabled={true} value={submitData.activities.length === 1 ? userData[0]?.formattedAddress : ''} />
                                </span>
                            </div>
                            {/* Display time & Duration input field */}
                            <div className="form-group input-group input-group-sm">
                                <span className='inputBoxStyle'>
                                    <input className="inputstyle border-none form-control form-control-sm" type="text" disabled={true} value={submitData.activities.length === 1 ? userData[0]?.displayTime + ",\t" + userData[0]?.duration : ""} />
                                </span>
                            </div>
                            {/* Notes input field */}
                            <div className="form-group input-group input-group-sm">
                                <span className='inputBoxStyle'>
                                    <textarea rows="3" className="inputstyle form-control form-control-sm" placeholder="Additional notes(Optional)" disabled={submitData.activities.length === 0} style={{ textTransform: "capitalize" }} value={(submitData.activities.length === 1) ? submitData?.notes : [submitData.activities.length > 1 ? submitData?.notes : ""]} onChange={e => { setSubmitData({ ...submitData, notes: e.target.value }) }} />
                                </span>
                            </div>
                            {/* classification buttons */}
                            <div style={{ display: "flex", justifyContent: "center", paddingBlock: "0.5rem", height: "3.4rem" }}>
                                {((submitData.category === "U" || submitData.category === "Unclassified")) ?
                                    <Tooltip  radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div>Unclassified</div>}><span style={{ backgroundColor: "#EEEEEE" }} className="icon-circle unclassifiedBtn btn-hover-none" onClick={() => { setSubmitData({ ...submitData, category: "U", billable: "N" }) }}>
                                        <img src={ufilled} height="20px" width="20px" alt="qmark" />
                                        <span style={{ fontSize: ".8em", fontWeight: "500" }}></span>
                                    </span>
                                    </Tooltip>
                                    :
                                    <Tooltip  radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div>Unclassified</div>}><span style={{ backgroundColor: "white", border: "1px solid rgba(112, 101, 101, 0.5)" }} className={submitData.activities.length === 0 ? "icon-circle unclassifiedBtn btn-hover-none" : "icon-circle unclassifiedBtn"} onClick={() => { submitData.activities.length > 0 && setSubmitData({ ...submitData, category: "U", billable: "N" }) }}>
                                        <img src={(submitData.category === "U" || submitData.category === "Unclassified") ? ufilled : u} height="20px" width="20px" alt="qmark2" />
                                    </span>
                                    </Tooltip>
                                }
                                {((submitData.category === "P" || submitData.category === "Personal")) ?
                                    <Tooltip  radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div>Personal</div>}><span style={{ backgroundColor: "#E1EBEF" }} className="icon-circle personalBtn btn-hover-none" onClick={() => { setSubmitData({ ...submitData, category: "P", billable: "N" }) }} >
                                        <img src={HomeIcon2} height="20px" width="20px" alt="home" />
                                        <span style={{ fontSize: ".8em", fontWeight: "500" }}></span>
                                    </span>
                                    </Tooltip>
                                    :
                                    <Tooltip  radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div>Personal</div>}><span style={{ backgroundColor: "white", border: "1px solid rgba(13, 117, 153, 0.5)" }} className={submitData.activities.length === 0 ? "icon-circle personalBtn btn-hover-none" : "icon-circle personalBtn"} onClick={() => { submitData.activities.length > 0 && setSubmitData({ ...submitData, category: "P", billable: "N" }) }}>
                                        <img src={(submitData.category === "P" || submitData.category === "Personal") ? HomeIcon2 : HomeIcon} height="20px" width="20px" alt="home2" />
                                    </span>
                                    </Tooltip>
                                }
                                {((submitData.category === "W" || submitData.category === "Work")) ?
                                    <Tooltip  radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div>Work</div>}><span style={{ backgroundColor: "#CAECE5", height: "fitContent" }} className="icon-circle workBtn btn-hover-none" onClick={() => { submitData.activities.length > 0 && setSubmitData({ ...submitData, category: "W" }) }} >
                                        <img src={BriefCase2} height="20px" width="20px" alt="work" />
                                        <span style={{ fontSize: ".8em", fontWeight: "500" }}></span>
                                    </span>
                                    </Tooltip>
                                    :
                                    <Tooltip  radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div>Work</div>}><span style={{ backgroundColor: "white", height: "fitContent", border: "1px solid rgba(0, 117, 94, 0.5)" }} className={submitData.activities.length === 0 ? "icon-circle workBtn btn-hover-none" : "icon-circle workBtn"} onClick={() => { submitData.activities.length > 0 && setSubmitData({ ...submitData, category: "W" }) }} >
                                        <img src={(submitData.category === "W" || submitData.category === "Work") ? BriefCase2 : BriefCase} height="20px" width="20px" alt="work" />
                                    </span>
                                    </Tooltip>
                                }
                                {((!bill) && submitData.billable === "Y") && (submitData.category === "W" || submitData.category === "Work") ?
                                    <Tooltip  radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div>Billable</div>}><span style={{ backgroundColor: "#FCEFEE", height: "fitContent" }} className="billingBtn btn-hover-none" onClick={() => {
                                        if (submitData.activities.length > 0 && submitData.category === "W") {
                                            setBill(!bill);

                                            setSubmitData({ ...submitData, billable: "N" });
                                        }
                                        else {
                                             if(!toast.isActive(toastId.current)) {
                                               return  toastId.current = toast.warn(`Only a 'Work' type visit can be classified as 'Billable'`);}
                                        
                                        }
                                    }} >
                                        <img src={dollarfilled} height="20px" width="20px" alt="bill" /><span style={{ fontSize: ".8em" }}></span>
                                    </span></Tooltip>
                                    :
                                    <Tooltip  radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div>Billable</div>}><span style={{ backgroundColor: "white", height: "fitContent", border: "1px solid rgba(187, 36, 31, 0.6)" }} className="billingBtn" onClick={() => {
                                        if (submitData.activities.length > 0 && submitData.category === "W") {

                                            setSubmitData({ ...submitData, billable: "Y" });
                                            setBill(!bill);

                                        }
                                        else {
                                            if(!toast.isActive(toastId.current)) {
                                                return  toastId.current = toast.warn(`Only a 'Work' type visit can be classified as 'Billable'`);}
                                                                                 }
                                    }} >
                                        <img src={dollar} height="20px" width="20px" alt="bill" /><span style={{ fontSize: ".8em" }}></span>
                                    </span></Tooltip>
                                }
                            </div>
                            <button disabled={submitData.activities.length === 0 || nameError} type="submit" className="saveBtn my-1" style={{fontWeight: "600"}}>
                                {/* Save */}
                                {(loading) ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Save"}
                            </button>
                            <ToastContainer />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
});

export default MapForm;
